import React from "react";

const ProductFeed = () => {
  return <div className="dashRightView p-5">ProductFeed</div>;
};

export default ProductFeed;
